'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2, _class3, _temp3;

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _util = require('../util');

var _util2 = _interopRequireDefault(_util);

var _utils = require('./utils');

var _data = require('../util/data');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

Function.prototype.$asyncbind = function $asyncbind(self, catcher) {
  var resolver = this;

  if (catcher === true) {
    if (!Function.prototype.$asyncbind.EagerThenable) Function.prototype.$asyncbind.EagerThenable = function factory(tick) {
      var _tasks = [];

      if (!tick) {
        try {
          tick = process.nextTick;
        } catch (ex) {
          tick = function tick(p) {
            setTimeout(p, 0);
          };
        }
      }

      function _untask() {
        for (var i = 0; i < _tasks.length; i += 2) {
          var t = _tasks[i + 1],
              r = _tasks[i];

          for (var j = 0; j < t.length; j++) {
            t[j].call(null, r);
          }
        }

        _tasks = [];
      }

      function isThenable(obj) {
        return obj && obj instanceof Object && typeof obj.then === 'function';
      }

      function EagerThenable(resolver) {
        function done(inline) {
          var w;
          if (_sync || phase < 0 || (w = _thens[phase]).length === 0) return;

          _tasks.push(result, w);

          _thens = [[], []];
          if (_tasks.length === 2) inline ? _untask() : tick(_untask);
        }

        function resolveThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 0;
          result = x;
          done(true);
        }

        function rejectThen(x) {
          if (isThenable(x)) return x.then(resolveThen, rejectThen);
          phase = 1;
          result = x;
          done(true);
        }

        function settler(resolver, rejecter) {
          _thens[0].push(resolver);

          _thens[1].push(rejecter);

          done();
        }

        function toString() {
          return 'EagerThenable{' + {
            '-1': 'pending',
            0: 'resolved',
            1: 'rejected'
          }[phase] + '}=' + result.toString();
        }

        this.then = settler;
        this.toString = toString;
        var _thens = [[], []],
            _sync = true,
            phase = -1,
            result;
        resolver.call(null, resolveThen, rejectThen);
        _sync = false;
        done();
      }

      EagerThenable.resolve = function (v) {
        return isThenable(v) ? v : {
          then: function then(resolve, reject) {
            return resolve(v);
          }
        };
      };

      return EagerThenable;
    }();
    return new Function.prototype.$asyncbind.EagerThenable(boundThen);
  }

  if (catcher) {
    if (Function.prototype.$asyncbind.wrapAsyncStack) catcher = Function.prototype.$asyncbind.wrapAsyncStack(catcher);
    return then;
  }

  function then(result, error) {
    try {
      return result && result instanceof Object && typeof result.then === 'function' ? result.then(then, catcher) : resolver.call(self, result, error || catcher);
    } catch (ex) {
      return (error || catcher)(ex);
    }
  }

  function boundThen(result, error) {
    return resolver.call(self, result, error);
  }

  boundThen.then = boundThen;
  return boundThen;
};

var UNIT_PADDING = 10;

/**
 * FIXME selectedKeys为数组，但是每选一次更新数组为单元素
 */
var Menu = (_temp = _class = function (_M$BaseComponent) {
  _inherits(Menu, _M$BaseComponent);

  function Menu(props) {
    _classCallCheck(this, Menu);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Menu).call(this, props));

    Object.assign(_this.state, {
      openKeys: props.openKeys || [],
      selectedKeys: props.selectedKeys || []
    });
    return _this;
  }

  _createClass(Menu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        openKeys: nextProps.openKeys || [],
        selectedKeys: nextProps.selectedKeys || []
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var prefixCls = _props.prefixCls;
      var children = _props.children;

      var basicPrefixCls = prefixCls + '-menu';

      var _state = this.state;
      var openKeys = _state.openKeys;
      var selectedKeys = _state.selectedKeys;


      return _react2.default.createElement(
        'div',
        { className: basicPrefixCls },
        _react2.default.Children.map(children, this._renderChildren.bind(this, {
          prefixCls: prefixCls, openKeys: openKeys, selectedKeys: selectedKeys,
          onTitleClick: this._handleClickSubMenu,
          onSelect: this._handleClickMenuItem
        }))
      );
    }
  }, {
    key: '_renderChildren',
    value: function _renderChildren(props, item) {
      return _react2.default.cloneElement(item, props);
    }
  }, {
    key: '_handleClickSubMenu',
    value: function _handleClickSubMenu(key) {
      var _this2 = this;

      var openKeys = this.state.openKeys;

      var index = openKeys.findIndex(function (item) {
        return item == key;
      });
      if (index == -1) {
        openKeys.push(key);
      } else {
        openKeys.splice(index, 1);
      }
      this.setState({ openKeys: openKeys }, function () {
        var onOpenChange = _this2.props.onOpenChange;

        onOpenChange && onOpenChange(_this2.state.openKeys);
      });
    }
  }, {
    key: '_handleClickMenuItem',
    value: function _handleClickMenuItem(key, node) {
      //单击事件直接抛到外部，选中状态由外部传入决定
      var onSelect = this.props.onSelect;

      onSelect && onSelect(key, node, this.state.selectedKeys);
    }
  }]);

  return Menu;
}(_util2.default.BaseComponent), _class.defaultProps = {
  prefixCls: 'mt'
}, _temp);
var SubMenu = (_temp2 = _class2 = function (_M$BaseComponent2) {
  _inherits(SubMenu, _M$BaseComponent2);

  function SubMenu(props) {
    _classCallCheck(this, SubMenu);

    var _this3 = _possibleConstructorReturn(this, Object.getPrototypeOf(SubMenu).call(this, props));

    var openKeys = props.openKeys;
    var eventKey = props.eventKey;

    Object.assign(_this3.state, {
      showMenuItem: openKeys.includes(eventKey) || false });
    return _this3;
  }

  _createClass(SubMenu, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var openKeys = nextProps.openKeys;
      var eventKey = nextProps.eventKey;

      this.setState({
        showMenuItem: openKeys.includes(eventKey) || false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var prefixCls = _props2.prefixCls;
      var children = _props2.children;
      var label = _props2.label;
      var icon = _props2.icon;
      var openKeys = _props2.openKeys;
      var selectedKeys = _props2.selectedKeys;
      var level = _props2.level;
      var onSelect = _props2.onSelect;
      var onTitleClick = _props2.onTitleClick;

      var basicPrefixCls = prefixCls + '-sub-menu';

      var showMenuItem = this.state.showMenuItem;


      return _react2.default.createElement(
        'div',
        { className: _util2.default.classNames(basicPrefixCls, _defineProperty({}, basicPrefixCls + '--open', showMenuItem)) },
        _react2.default.createElement(
          'div',
          { className: basicPrefixCls + '__label',
            style: { paddingLeft: level * UNIT_PADDING + UNIT_PADDING },
            onClick: this._toggleMenu },
          _react2.default.createElement(
            'span',
            { className: basicPrefixCls + '__icon' },
            (0, _utils.buildIcon)(icon)
          ),
          _react2.default.createElement(
            'span',
            null,
            label
          ),
          _react2.default.createElement('span', { className: basicPrefixCls + '__expand ' + _data.IconPrefixCls + ' ' + _data.IconPrefixCls + '-angle-right' })
        ),
        showMenuItem && _react2.default.Children.map(children, this._renderChildren.bind(this, {
          prefixCls: prefixCls, selectedKeys: selectedKeys, openKeys: openKeys,
          onSelect: onSelect, onTitleClick: onTitleClick
        }))
      );
    }
  }, {
    key: '_renderChildren',
    value: function _renderChildren(props, item) {
      return _react2.default.cloneElement(item, props);
    }
  }, {
    key: '_toggleMenu',
    value: function _toggleMenu(e) {
      var _this4 = this;

      this.setState({
        showMenuItem: !this.state.showMenuItem
      }, function () {
        var _props3 = _this4.props;
        var onTitleClick = _props3.onTitleClick;
        var eventKey = _props3.eventKey;

        onTitleClick && onTitleClick(eventKey, e);
      });
    }
  }]);

  return SubMenu;
}(_util2.default.BaseComponent), _class2.defaultProps = {
  prefixCls: 'mt'
}, _temp2);
var Item = (_temp3 = _class3 = function (_M$BaseComponent3) {
  _inherits(Item, _M$BaseComponent3);

  function Item(props) {
    _classCallCheck(this, Item);

    var _this5 = _possibleConstructorReturn(this, Object.getPrototypeOf(Item).call(this, props));

    var selectedKeys = props.selectedKeys;
    var eventKey = props.eventKey;

    Object.assign(_this5.state, {
      active: selectedKeys.includes(eventKey) || false
    });
    return _this5;
  }

  _createClass(Item, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var selectedKeys = nextProps.selectedKeys;
      var eventKey = nextProps.eventKey;

      this.setState({
        active: selectedKeys.includes(eventKey) || false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props;
      var prefixCls = _props4.prefixCls;
      var children = _props4.children;

      var basicPrefixCls = prefixCls + '-menu-item';

      var active = this.state.active;


      return _react2.default.createElement(
        'div',
        { className: _util2.default.classNames(basicPrefixCls, _defineProperty({}, basicPrefixCls + '--active', active)), onClick: this._clickItem },
        children
      );
    }
  }, {
    key: '_clickItem',
    value: function _clickItem(e) {
      //单击事件直接抛到外部，active由外部传入决定
      var _props5 = this.props;
      var onSelect = _props5.onSelect;
      var eventKey = _props5.eventKey;
      var node = _props5.node;

      onSelect && onSelect(eventKey, node, e);
    }
  }]);

  return Item;
}(_util2.default.BaseComponent), _class3.defaultProps = {
  prefixCls: 'mt'
}, _temp3);


Menu.SubMenu = SubMenu;
Menu.Item = Item;
exports.default = Menu;